import s from './NameCellRenderer.scss'
import cn from 'classnames'
import { Link } from 'react-router-dom'

const NameCellRenderer = ({ data }) => {
  if (!data) return null
  const { id, name, noBid } = data

  return (
    <Link className={cn({ [s.noBid]: noBid }, s.link)} to={`/companies/${id}`}>
      {name}
    </Link>
  )
}

export default NameCellRenderer
